import {TextStyle} from 'react-native';

import {lineHeight, resolveWeight, type} from '../../design-system/tokens';

/**
 * Footer type styles that `type.*` lacks. Copied from the DIS-1859 prototype
 * (`prototypes/siteChrome/chromeType.ts`), footer members only. Each one reuses a token's size
 * and resolves its weight through `resolveWeight()`, so Android still gets the right face.
 *
 * SHORTCUT: token gaps, recorded in spec.json tokenGaps: 16/500, 12/500, 12/300 are "new token
 * proposal: Medium and Light weights recur in header and footer; type.* has neither at these
 * sizes". Upgrade path: add the agreed styles to app/design-system/tokens/typography.ts
 * (DIS-1735) and replace each member below with the token.
 */
const size16 = type.button.category.fontSize;
const size12 = type.paragraph.p3.fontSize;

export const chromeType = Object.freeze({
  /** Footer column headings. Figma draws Button/Category's line height (1.0). */
  label16Medium: {
    fontSize: size16,
    ...resolveWeight('medium'),
    ...lineHeight.button.category,
  } as TextStyle,
  /** RSA links. */
  // Figma draws the 12 px footer text leading-none (footer/desk 476:7181).
  label12Medium: {fontSize: size12, lineHeight: size12, ...resolveWeight('medium')} as TextStyle,
  /** RSA sentence. */
  body12Light: {fontSize: size12, lineHeight: size12, ...resolveWeight('light')} as TextStyle,
});
